import { render } from "./Wip.vue?vue&type=template&id=442a2cf6"
import script from "./Wip.vue?vue&type=script&lang=js"
export * from "./Wip.vue?vue&type=script&lang=js"
script.render = render

export default script